import React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { AppBulkEditAction } from "@components"
import { isReportMultipleModalLoading, reportListMultipleData } from "Pages/ReportsAlerts/Reports/@signals"
import { MULTIPLE_MODAL_LOADING, MULTIPLE_OPTIONS, RENTAL_DATES_OPTIONS } from "Pages/ReportsAlerts/Reports/@constants"
import { useComputed } from "@preact/signals-react"

export const reportsCountLabel = count => `${count} report${count === 1 ? '' : 's'}`


export default function ReportMultipleModalButtons() {

	const validation = useComputed(() => {
		return reportListMultipleData.value.key === MULTIPLE_OPTIONS.DATES
			? reportListMultipleData.value.reportsInfo.every(({ rentalDateOption }) => rentalDateOption === RENTAL_DATES_OPTIONS.SPECIFIC_DAYS) && !!reportListMultipleData.value.values.length
			: !!reportListMultipleData.value.values.length
	})
	const frequencyValidation = useComputed(() => {
		return reportListMultipleData.value?.manuallyExecution || !!(reportListMultipleData.value?.idFrequencyWhen?.length && reportListMultipleData.value?.frequencyHours?.length)
	})
	const executionDatesValidation = useComputed(() => {
		const min = reportListMultipleData.value?.executionDateMin
		const max = reportListMultipleData.value?.executionDateMax
		return (!!min && !!max) || (!min && !max)
	})
	const optionSelected = useComputed(() => reportListMultipleData.value.key)
	const reports = reportsCountLabel(reportListMultipleData.value?.reportsInfo?.length || 0)

	if (optionSelected.value === MULTIPLE_OPTIONS.EXECUTION_DATES) return <AppBulkEditAction
		disabled={!executionDatesValidation.value}
		loading={!!isReportMultipleModalLoading.value}
		onClick={() => {
			isReportMultipleModalLoading.value = MULTIPLE_MODAL_LOADING.UPDATE_EXECUTION_DATES
		}}
		startIcon={<IconSeeker icon="check"/>}
	>
		Apply to {reports}
	</AppBulkEditAction>

	if (optionSelected.value === MULTIPLE_OPTIONS.FREQUENCY) return <AppBulkEditAction
		disabled={!frequencyValidation.value}
		loading={!!isReportMultipleModalLoading.value}
		onClick={() => {
			isReportMultipleModalLoading.value = MULTIPLE_MODAL_LOADING.UPDATE
		}}
		startIcon={<IconSeeker icon="check"/>}
	>
		Apply to {reports}
	</AppBulkEditAction>

	return <>
		<AppBulkEditAction
			danger
			disabled={!validation.value}
			loading={!!isReportMultipleModalLoading.value}
			onClick={() => {
				isReportMultipleModalLoading.value = MULTIPLE_MODAL_LOADING.REMOVE
			}}
			startIcon={<IconSeeker icon="trash-can"/>}
		>
			Remove from {reports}
		</AppBulkEditAction>
		<AppBulkEditAction
			disabled={!validation.value}
			loading={!!isReportMultipleModalLoading.value}
			onClick={() => {
				isReportMultipleModalLoading.value = MULTIPLE_MODAL_LOADING.ADD
			}}
			startIcon={<IconSeeker icon="plus"/>}
		>
			Add to {reports}
		</AppBulkEditAction>
	</>
}
